// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

const env = (reactAppKey, legacyKey) =>
  process.env[reactAppKey] || process.env[legacyKey] || '';

const firebaseConfig = {
  apiKey: env('REACT_APP_FIREBASE_API_KEY', 'FIREBASE_API_KEY'),
  authDomain: env('REACT_APP_FIREBASE_AUTH_DOMAIN', 'FIREBASE_AUTH_DOMAIN'),
  projectId: env('REACT_APP_FIREBASE_PROJECT_ID', 'FIREBASE_PROJECT_ID'),
  storageBucket: env('REACT_APP_FIREBASE_STORAGE_BUCKET', 'FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', 'FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('REACT_APP_FIREBASE_APP_ID', 'FIREBASE_APP_ID'),
  measurementId: env('REACT_APP_FIREBASE_MEASUREMENT_ID', 'FIREBASE_MEASUREMENT_ID')
};

const app = initializeApp(firebaseConfig);
const hasStorageBucket = Boolean(firebaseConfig.storageBucket);
const storage = hasStorageBucket ? getStorage(app) : null;
const db = getFirestore(app);

let analyticsInstance;

// Initialize Analytics only after explicit consent
function initAnalytics() {
  if (typeof window === 'undefined') return null;
  if (analyticsInstance) return analyticsInstance;
  if (!firebaseConfig.measurementId) {
    console.warn('Firebase measurementId fehlt, Analytics wird nicht initialisiert.');
    return null;
  }

  try {
    analyticsInstance = getAnalytics(app);
    return analyticsInstance;
  } catch (error) {
    console.error('Fehler beim Initialisieren von Firebase Analytics:', error);
    return null;
  }
}

export { storage, db, initAnalytics, hasStorageBucket };
